import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-white" data-id="element-120" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-121" data-mp="223eltma3nb3z">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-zinc-100 border border-zinc-200 rounded-3xl p-8 md:p-12 text-center shadow-sm" data-id="element-122" data-mp="222dbjk0wqsnb">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-white text-green-600 mb-8 border border-green-600/20" data-id="element-123" data-mp="14dl1zc90e48z">
            <ShieldCheck size={48} aria-hidden="true" data-id="element-124" data-mp="1edkaxa9cbwmd" />
          </div>
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-6 text-zinc-950" data-id="element-125" data-mp="qo9j4i9yxckd">
            7-Day Refund Policy
          </h2>
          <div className="space-y-6 text-lg text-zinc-700 max-w-2xl mx-auto" data-id="element-126" data-mp="lpy5dwgjyhwv">
            <p data-id="element-127" data-mp="ozrsoo32f265">You have 7 days to review the material after purchase.</p>
            <p className="font-medium text-zinc-950" data-id="element-128" data-mp="oxp13zm9l0zb">
              If the material you receive is incorrect, defective, incomplete or materially
              different from what was advertised, contact our support team within the applicable
              period and we will review the case according to our refund policy.
            </p>
            <p className="text-sm text-zinc-500 mt-8" data-id="element-129" data-mp="61ffmr91985a">
              The product is delivered digitally in PDF format.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}